import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import FormatSizeOutlinedIcon from '@mui/icons-material/FormatSizeOutlined';
import ReaderConfigurationMenu from '../../features/ReaderConfiguration/ReaderConfigurationMenu';
import TableOfContentsMenu from '../TableOfContentsMenu';
import MenuIcon from '@mui/icons-material/Menu';
import { FC, type ReactElement } from 'react';
import NavigationMenu from '../NavigationMenu';

export interface ReaderMenuItemConfig {
  icon: ReactElement;
  labelKey: string;
  content: FC;
  id: string;
  titleId?: string;
}

export enum ReaderMenuViews {
  HOME = 'home',
  TABLE_OF_CONTENTS = 'table-of-contents',
  CONFIG = 'config',
  NOTES = 'notes',
}

export const READER_MENU_ITEMS: ReaderMenuItemConfig[] = [
  {
    icon: <MenuIcon />,
    labelKey: 'readingView.menu.navigation.label',
    content: NavigationMenu,
    id: ReaderMenuViews.HOME,
  },
  {
    icon: <AutoStoriesOutlinedIcon />,
    labelKey: 'readingView.readerMenu.tableOfContents.label',
    content: TableOfContentsMenu,
    id: ReaderMenuViews.TABLE_OF_CONTENTS,
  },
  {
    icon: <FormatSizeOutlinedIcon />,
    labelKey: 'readingView.readerMenu.readerConfiguration.label',
    content: ReaderConfigurationMenu,
    id: ReaderMenuViews.CONFIG,
    titleId: 'reader-configuration-menu-title',
  },
  // {
  //   icon: <BookOutlinedIcon />,
  //   label: 'Muistiinpanot ja merkinnät',
  //   ariaDescription: 'View and manage document bookmarks',
  //   content: AnnotationsMenu,
  //   id: ReaderMenuViews.NOTES,
  // },
];
